import * as React from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import {Route, RouteChildrenProps, Switch} from 'react-router-dom';
// async components
import {AsyncApiKeysListComponent} from '../components/AsyncComponent/AsyncComponent';
import {config} from "../config";

const ApiKeys: React.FunctionComponent<RouteChildrenProps> = ({match}) => {
    const {t: translate} = useTranslation();
    return (
        <div className="content-wrapper">
            <Helmet>
                <title>{`${config.app.name} - ${translate('apiKeys.name')}`}</title>
                <meta name="description" content="Api Keys"/>
            </Helmet>
            <Switch>
                <Route exact path={`${match?.url}`} component={AsyncApiKeysListComponent}/>
            </Switch>
        </div>
    );
};

export default ApiKeys;
